module.exports = __webpack_public_path__ + "media/images/home/fitness-1b77ba4132686ed086c26fcaaa8da21f.jpg";